import './App.css';
import './TotemMini.css';
import Totem2 from './Totem2';
import img_wifi from './wifi.png';
import img_wifi_gif from './wifi.gif';

function TotemMini({ creativeURL }) {
    return (
        <div>
            <div>
                <img
                    src={img_wifi_gif}
                    className='totem-mini-wifi'
                />
            </div>
            <div className='totem-mini-cover'>
                <Totem2
                    creativeURL={creativeURL}
                    baseColor='white'
                    height='100%'
                    width='100%'
                    color='#dcdee0'
                />
            </div>
        </div>
    );
}

export default TotemMini;